<!-- STANDARD Modal Header -->
<div class="modal-header">
  <h3 class="modal-title">{{modalTitle}}</h3>
  <div class="header-actions">
    <i class="fa"  
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"  
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times"></i>
  </div>
</div>

<!-- Entity table removed - not needed for this component -->

<!-- STANDARD Modal Body -->
<div class="modal-body" [hidden]="minimise">
  @if (crudLoading) {
<div class="formLoader">
    <i class="fa fa-spinner fa-spin gt-refresh"></i>
  </div>
}
  
  @if (!crudLoading) {
<div>
    <div style="margin-left: 30px; margin-right: 30px; margin-bottom: 30px">
      <div class="divShadow">
        <div class="table-responsive">
          
          <!-- Data Table -->
          <table class="gt-reclass-table table table-hover table-bordered table-striped table-condensed custom-table">
            <thead>
              <tr>
                <th>
                  <i class="fa pr-5 pointer" aria-hidden="true"
                     [ngClass]="{'fa-sort': sort_key['1'] == 0,
                                'fa-sort-alpha-asc': sort_key['1'] == 1,
                                'fa-sort-alpha-desc': sort_key['1'] == 2}"
                     (click)="orderByField='LEID'; sortBy('1', sort_key['1'])"></i>
                  LEID
                </th>
                <th>
                  <i class="fa pr-5 pointer" aria-hidden="true"
                     [ngClass]="{'fa-sort': sort_key['2'] == 0,
                                'fa-sort-alpha-asc': sort_key['2'] == 1,
                                'fa-sort-alpha-desc': sort_key['2'] == 2}"
                     (click)="orderByField='CDR_NO'; sortBy('2', sort_key['2'])"></i>
                  Tax Code
                </th>
                <th>
                  <i class="fa pr-5 pointer" aria-hidden="true"
                     [ngClass]="{'fa-sort': sort_key['3'] == 0,
                                'fa-sort-alpha-asc': sort_key['3'] == 1,
                                'fa-sort-alpha-desc': sort_key['3'] == 2}"
                     (click)="orderByField='REPORTING_PERIOD'; sortBy('3', sort_key['3'])"></i>
                  Reporting Period
                </th>
                <th>
                  <i class="fa pr-5 pointer" aria-hidden="true"
                     [ngClass]="{'fa-sort': sort_key['4'] == 0,
                                'fa-sort-alpha-asc': sort_key['4'] == 1,
                                'fa-sort-alpha-desc': sort_key['4'] == 2}"
                     (click)="orderByField='CURR'; sortBy('4', sort_key['4'])"></i>
                  Currency
                </th>
                <th>
                  <i class="fa pr-5 pointer" aria-hidden="true"
                     [ngClass]="{'fa-sort': sort_key['5'] == 0,
                                'fa-sort-alpha-asc': sort_key['5'] == 1,
                                'fa-sort-alpha-desc': sort_key['5'] == 2}"
                     (click)="orderByField='ME_CODE'; sortBy('5', sort_key['5'])"></i>
                  ME Code
                </th>
                <th>
                  <i class="fa pr-5 pointer" aria-hidden="true"
                     [ngClass]="{'fa-sort': sort_key['6'] == 0,
                                'fa-sort-alpha-asc': sort_key['6'] == 1,
                                'fa-sort-alpha-desc': sort_key['6'] == 2}"
                     (click)="orderByField='ACCT_DESC'; sortBy('6', sort_key['6'])"></i>
                  Sub Category
                </th>
                <th>
                  <i class="fa pr-5 pointer" aria-hidden="true"
                     [ngClass]="{'fa-sort': sort_key['7'] == 0,
                                'fa-sort-alpha-asc': sort_key['7'] == 1,
                                'fa-sort-alpha-desc': sort_key['7'] == 2}"
                     (click)="orderByField='SUB_CATG_AMOUNT'; sortBy('7', sort_key['7'])"></i>
                  Sub Category Amt
                </th>
              </tr>
            </thead>
            
            <!-- No Records Body -->
            @if (noRecords) {
<tbody>
              <tr>
                <td class="loading-table" colspan="7">
                  <div style="margin-top: 20px">
                    <b>No Data Available</b>
                  </div>
                </td>
              </tr>
            </tbody>
}
            
            <!-- Data Body -->
            @if (!noRecords) {
<tbody>
              @for (t of displaySubcategory; track $index) {
<tr>
                <td>{{ t.LEID }}</td>
                <td>{{ t.CDR_NO }}</td>
                <td>{{ t.REPORTING_PERIOD }}</td>
                <td>{{ t.CURR }}</td>
                <td>{{ t.ME_CODE }}</td>
                <td>{{ t.ACCT_DESC }}</td>
                <td class="text-right">{{ t.SUB_CATG_AMOUNT | number:'1.0-0' }}</td>
              </tr>
}
            </tbody>
}
          </table>
          
        </div>
      </div>
    </div>
  </div>
}
</div>

<!-- STANDARD Footer -->
<div class="modal-footer" [hidden]="minimise">
  <button class="cancel-button"  
          type="button"  
          (click)="cancel()">Close</button>
</div>
